import React from 'react';

const Loader = ({ inline = false }) => {
  return (
    <div
      data-testid="loader-wrapper"
      className={`Loader-wrapper ${inline ? 'inline' : ''}`}
    >
      <div className="Loader" />
    </div>
  );
};

export default Loader;
